// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nq-0";
export var assigneeDetails = "_nq-1";
export var assigneeInfo = "_nq-2";
export var dropdownContainer = "_nq-4";
export var dropdownImage = "_nq-5";
export var editAssigneeInfo = "_nq-3";
export var editAssigneeModalContainer = "_nq-6";
export var hidden = "_nq-8";
export var input = "_nq-7";